import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {
  Box,
  Menu,
  Avatar,
  Typography,
  Divider,
  Button,
  IconButton,
  Chip,
  useMediaQuery,
} from '@mui/material';

import { Stack } from '@mui/system';

import Scrollbar from 'src/components/custom-scroll/Scrollbar';
import { useDispatch, useSelector } from 'react-redux';
import { loginFailureMsg, logout } from 'src/store/auth/UserAuthSlice.jsx';
import { GetUser } from 'src/hooks/useAuthentication';
import { flush } from 'src/store/auth/userRoleSlice';
import ProfileImg from 'src/assets/images/profile/user-1.jpg'

const Profile = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = GetUser();
  const customizer = useSelector((state) => state.customizer);
  const lgUp = useMediaQuery((theme) => theme.breakpoints.up('lg'));

  const [avatarColor, setAvatarColor] = useState('');

  const [anchorEl2, setAnchorEl2] = useState(null);
  const handleClick2 = (event) => {
    setAnchorEl2(event.currentTarget);
  };
  const handleClose2 = () => {
    setAnchorEl2(null);
  };
  const handleLogout = () => {
    // Dispatch the logout action
    localStorage.removeItem('avatarColor');
    dispatch(loginFailureMsg({ message: 'Log Out Successfully' }));
    localStorage.removeItem('postLoginRedirect');
    dispatch(logout());
    dispatch(flush());
    navigate('/auth/login');
  };

  const getRandomColor = () => {
    // Generate random color in hex format
    return `#${Math.floor(Math.random() * 16777215).toString(16)}`;
  };

  const getInitials = (name) => {
    // return name
    //   .split(' ')
    //   .map((part) => part.charAt(0).toUpperCase())
    //   .join('');

    if (!name) return '*';
    return name.trim().charAt(0).toUpperCase();
  };

  const avatarStyle = (s) => {
    let avatarSize = {};
    switch (s) {
      case 'xs':
        avatarSize = {
          width: 40,
          height: 40,
          fontSize: '20px',
        };
        break;
      case 'lg':
        avatarSize = {
          width: 95,
          height: 95,
          fontSize: '3.5rem',
        };
        break;
      case 'md':
        avatarSize = {
          width: 60,
          height: 60,
          fontSize: '2rem',
        };
        break;
      default:
        avatarSize = {
          width: 95,
          height: 95,
          fontSize: '3.5rem',
        };
        break;
    }

    return {
      ...avatarSize,
      backgroundColor: avatarColor,
      color: '#fff',
    };
  };

  useEffect(() => {
    const storedColor = localStorage.getItem('avatarColor');
    if (storedColor) {
      setAvatarColor(storedColor);
    } else {
      const randomColor = getRandomColor();
      setAvatarColor(randomColor);
      localStorage.setItem('avatarColor', randomColor);
    }
  }, []);

  const colorArray = [
    { id: 1, backgroundColor: '#ffe0b2', color: '#e65100' },
    { id: 2, backgroundColor: '#e0f7fa', color: '#00695c' },
    { id: 3, backgroundColor: '#f3e5f5', color: '#4a148c' },
    { id: 4, backgroundColor: '#e8f5e9', color: '#2e7d32' },
    { id: 5, backgroundColor: '#ffebee', color: '#c62828' },
    { id: 6, backgroundColor: '#e1f5fe', color: '#01579b' },
    { id: 7, backgroundColor: '#fff3e0', color: '#ef6c00' },
    { id: 8, backgroundColor: '#ede7f6', color: '#4527a0' },
    { id: 9, backgroundColor: '#f1f8e9', color: '#558b2f' },
    { id: 10, backgroundColor: '#fce4ec', color: '#ad1457' },
  ];

  return (
    <Box>
      <IconButton
        size="large"
        aria-label="show 11 new notifications"
        color="inherit"
        aria-controls="msgs-menu"
        aria-haspopup="true"
        sx={{
          ...(typeof anchorEl2 === 'object' && {
            color: 'primary.main',
          }),
        }}
        onClick={handleClick2}
      >
        <Avatar
         src={user?.profileImg || ProfileImg}
         alt={user?.profileImg || ProfileImg}
         sx={{
           width: 35,
           height: 35,
         }}
        />

        {/* <Avatar sx={avatarStyle('xs')}>{user ? getInitials(user.first_name) : ''}</Avatar> */}
      </IconButton>
      {/* ------------------------------------------- */}
      {/* Message Dropdown */}
      {/* ------------------------------------------- */}
      <Menu
        id="msgs-menu"
        anchorEl={anchorEl2}
        keepMounted
        open={Boolean(anchorEl2)}
        onClose={handleClose2}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        sx={{
          '& .MuiMenu-paper': {
            width: '360px',
          },
        }}
      >
        <Scrollbar sx={{ height: '100%', maxHeight: '85vh' }}>
          <Box p={1}>
            {/* <Typography variant="h5" textAlign={`center`}>
              User Profile
            </Typography> */}

            {!lgUp && (
              <Typography variant="body2" textAlign={`center`} fontWeight={`bold`}>
               Sastraprakasika
              </Typography>
            )}

            <Link to={`/masters/user/view/${user ? user.id : 0}`}>
              <Stack direction="row" py={3} spacing={2} alignItems="center" mx={3}>
                <Avatar
                 src={user?.profileImg || ProfileImg}
                 alt={user?.profileImg || ProfileImg}
                 sx={{width: 95, height: 95}}
                />

                {/* <Avatar sx={lgUp ? avatarStyle('lg') : avatarStyle('md')}>
                  {user ? getInitials(user.first_name) : ''}
                </Avatar> */}

                <Box>
                  <Typography
                    variant={lgUp ? 'h5' : 'body2'}
                    color="textPrimary"
                    fontWeight={`bold`}
                    sx={{ color: customizer.activeMode === 'light' ? '#082292' : '#fff' }}
                  >
                    {user ? user.firstName : ""}

                  </Typography>

                  <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
                    {user?.email ?? ' - '}
                  </Typography>
                </Box>
              </Stack>
            </Link>

            <Divider />

            <Box mt={2} display={`flex`} justifyContent={`center`}>
              {/* <Button
                onClick={handleLogout}
                variant="outlined"
                color="error"
                component={Link}
                fullWidth
              >
                Logout
              </Button> */}

              <Button
                onClick={handleLogout}
                variant="outlined"
                color="error"
                component={Link}
                fullWidth
                sx={{
                  width: '50%',
                  color: customizer.activeMode == 'light' ? '#ff0a54' : '#fff',
                  borderColor: '#ff0a54',
                  backgroundColor: customizer.activeMode == 'light' ? '' : '#ff0a54',
                  '&:hover': {
                    color: customizer.activeMode == 'light' ? '#FFF' : '#ff0a54',
                    backgroundColor: customizer.activeMode == 'light' ? '#ff0a54' : '#171c23',
                    boxShadow: customizer.activeMode == 'light' ? '' : '1px 1px 3px #ff0a54',
                    fontWeight: 'bold',
                    borderColor: '#ff0a54',
                  },
                }}
              >
                Logout
              </Button>
            </Box>
          </Box>
        </Scrollbar>
      </Menu>
    </Box>
  );
};

export default Profile;
